export default __webpack_public_path__ + "static/media/Crossing-Yellow-24x24.99a4b204.svg";